import { css } from 'emotion';

import type { GeofenceColor } from '@cobliteam/common-types/src/geofenceV3';
import { GeofenceType } from '@cobliteam/common-types/src/geofenceV3';

import { GeofenceTypeItems } from '@cobliteam/base-components';

import { colors } from '../../styles';

const getGeojsonStyle = (type: GeofenceType, color?: GeofenceColor) => {
  let colorValue = GeofenceTypeItems[type].activeColor || colors.gray.dark;

  if (type === GeofenceType.STATE || type === GeofenceType.CITY) {
    colorValue = color;
  }

  return {
    color: colorValue,
    weight: 1,
    fillOpacity: 0.1,
  };
};

const popup = css`
  width: 360px;
  box-shadow: 2px 2px 10px 0 rgba(157, 169, 182, 0.2);
  border: 1px solid ${colors.gray.light};
  border-radius: 5px;
  box-sizing: content-box;
  background-color: ${colors.white};
  .leaflet-popup-content-wrapper {
    padding: 0;
    border-radius: inherit;
  }

  .leaflet-popup-content {
    margin: 0;
    border-radius: inherit;
  }

  :before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-top: 11px solid ${colors.gray.light};
    border-right: 11px solid transparent;
    border-left: 11px solid transparent;
    left: calc(50% - 11px);
    bottom: -11px;
  }

  :after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-top: 10px solid ${colors.white};
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    left: calc(50% - 10px);
    bottom: -10px;
  }
`;

export default {
  getGeojsonStyle,
  popup,
};
